var SignatureFormat = /* @__PURE__ */ ((SignatureFormat2) => {
  SignatureFormat2["TEXT"] = "text/plain";
  SignatureFormat2["POINTS"] = "points/json";
  return SignatureFormat2;
})(SignatureFormat || {});
var SignatureMode = /* @__PURE__ */ ((SignatureMode2) => {
  SignatureMode2["DRAW"] = "draw";
  SignatureMode2["TYPE"] = "type";
  SignatureMode2["UPLOAD"] = "upload";
  return SignatureMode2;
})(SignatureMode || {});
var SignatureView = /* @__PURE__ */ ((SignatureView2) => {
  SignatureView2["DRAW"] = "draw";
  SignatureView2["TYPE"] = "type";
  SignatureView2["IMAGE"] = "image";
  SignatureView2["UPLOAD"] = "upload";
  return SignatureView2;
})(SignatureView || {});
export {
  SignatureFormat,
  SignatureMode,
  SignatureView
};
//# sourceMappingURL=signature-types.js.map
